import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Likes from "../../components/likes/Likes";
import Comments from "../../components/comment/Comments";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';


import axios from "axios";
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`

const Forum = () => {
   
    const [thread, setThread] = useState("");
    const navigate = useNavigate();
    const [threadList, setThreadList] = useState([]);
    const [sort,setSort] = useState("Оберіть фільтр")
    const createThread = () => {
        fetch(`${SERVER}/api/create/thread`, {
            method: "POST",
            body: JSON.stringify({
                thread,
                userId: JSON.parse(localStorage.getItem("user")).ID_user,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                alert(data.message);
              
                setThreadList([...threadList,data])
                navigate('/forum')
            })
            .catch((err) => console.error(err));
    };
    
    const handleSort = (e)=>{
        setSort(e.target.text)
    }
    
    useEffect(() => {
        if(sort=="Найновіші"){
            threadList.sort((a, b) => {
                const likesA = Number(a.likes) || 0;
                const likesB = Number(b.likes) || 0;
                return likesB - likesA; 
            });
        }else{
            threadList.sort((a, b) => new Date(b.date) - new Date(a.date));
        }
     
    }, [sort]);

    //👇🏻 Triggered when the form is submitted
    const handleSubmit = (e) => {
        e.preventDefault();
        //👇🏻 Calls the function
        createThread();
        setThread("");
    };

    useEffect(() => {
   
                fetch(`${SERVER}/api/all/threads`)
                    .then((res) => res.json())
                    .then((data) => {
                      
                        setThreadList(data.threads)
                    })
                    .catch((err) => console.error(err));
    
    }, [navigate]);

    // useEffect(() => {
    //     const checkUser = () => {
    //         if (!localStorage.getItem("_id")) {
    //             navigate("/");
    //         } else {
    //             console.log("Authenticated");
    //         }
    //     };
    //     checkUser();
    // }, [navigate]);

    const getLikes = async(id)=>{
        try{
            const res = await axios.post(`${SERVER}/api/thread/likes`,{forumId:id})
            
            return res.data.likes
        }catch(e){
            console.log(e)
        }
    }
    const getComments = async(id)=>{
        try{
            const res = await axios.post(`${SERVER}/api/thread/comments`,{forumId:id})
            
            return res.data.comments
        }catch(e){
            console.log(e)
        }
    }
    return (
        <>
          
          <main className='home'>
                <h2 className='homeTitle'>Створити обговорення</h2>
                <form className='homeForm' onSubmit={handleSubmit}>
                    <div className='home__container'>
                        <label htmlFor='thread'>Задайте питання ...</label>
                        <input
                            type='text'
                            name='thread'
                            required
                            value={thread}
                            style={{height:'30px',marginRight:'2%'}}
                            onChange={(e) => setThread(e.target.value)}
                        />
                    </div>
                    {JSON.parse(localStorage.getItem("user")).ID_user ? <button type="submit" style={{backgroundColor: '#674188 !important'}} className='homeBtn'>ВІДПРАВИТИ</button > : <button  className='homeBtn' style={{backgroundColor: '#674188 !important'}} onClick={()=>{navigate('/login')}}>УВІЙТИ</button >}
                    
                </form>
<div style={{display: 'flex', justifyContent:'flex-end',width:'75%'}}>
<DropdownButton
        as={ButtonGroup}
        title={sort}
        id="bg-vertical-dropdown-1"
      >
        <Dropdown.Item eventKey="1" onClick={handleSort} value='top'>Більш залайкані</Dropdown.Item>
        <Dropdown.Item eventKey="2" onClick={handleSort} value='recent'>Найновіші</Dropdown.Item>
      </DropdownButton>
</div>
                
    
                <div className='thread__container'>
                    {threadList ? threadList.map((thread) => (
                        
                        <div className='thread__item' key={thread.idforum}>
                            <p>{thread.message}</p>
                            <div className='react__container'>
                                <Likes getLikes={getLikes} threadId={thread.idforum} category={'forum'}/>
                                <Comments
                                    getComments={getComments}
                                    threadId={thread.idforum}
                                    title={thread.message}
                                />
                            </div>
                        </div>
                    )) : null}
                </div>
            </main>
        </>
    );
};

export default Forum;